import React, { useEffect, useState } from 'react'
import { CAccordionBody, CAccordionHeader, CAccordionItem, CButton, CFormLabel, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import { Plus } from 'lucide-react'
import Graytextarea from '../../components/Graytextarea'
import { backgroundColor } from '@syncfusion/ej2-richtexteditor/src/rich-text-editor/models/items'
import { useIndexedDB } from '../../context/IndexedContext'

const ProviderAlert = ({ diagnosisName, noteStructureRef, loggedUserProvider, patientID, changesInTreatmentShell, setChangesInTreatmentShell, noteCallType }) => {
  const [textValue, setTextValue] = useState('')
  const [modalText, setModalText] = useState('')

  const { saveOfflineData, getOfflineData, getOpenChartOfflineData, saveOpenChartOfflineData } = useIndexedDB()

  useEffect(() => {
    const alertText = noteStructureRef?.current?.alertData?.[diagnosisName] || ''
    setModalText(alertText)
    setTextValue(alertText)
  }, [])

  const [visible, setVisible] = useState(false)

  const handleAddToOfflineAlertData = async (modalText) => {
    let dataOffline = noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()
    if (dataOffline) {
      dataOffline = {
        ...dataOffline,
        [loggedUserProvider?.ID]: {
          ...dataOffline[loggedUserProvider?.ID],
          [patientID]: {
            ...dataOffline[loggedUserProvider?.ID][patientID],
            currentNote: {
              ...dataOffline[loggedUserProvider?.ID][patientID].currentNote,
              data: {
                ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data,
                alertData: {
                  ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data.alertData,
                  [diagnosisName]: modalText,
                },
              },
            },
            saveDraft: true,
          },
        },
      }
    }
    // await saveOfflineData(dataOffline)
    noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(dataOffline) : await saveOfflineData(dataOffline)
  }

  const handleSubmit = async () => {
    setVisible(false)
    if (!noteStructureRef?.current?.alertData) {
      noteStructureRef.current.alertData = {}
    }
    noteStructureRef.current = {
      ...noteStructureRef.current,
      alertData: {
        ...noteStructureRef.current.alertData,
        [diagnosisName]: modalText,
      },
    }
    await handleAddToOfflineAlertData(modalText)
    setTextValue(modalText)
    setChangesInTreatmentShell((p) => !p)
  }

  return (
    <>
      <div>
        <CAccordionItem className="border">
          <CAccordionHeader>
            <div className="d-flex gap-2 align-items-center">
              <h7 className="p-0 m-0">Alert</h7>
              {/* <div>
                                <CFormLabel
                                    className="d-flex mt-2 flex-column align-items-center justify-content-center shadow "
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        e.preventDefault()
                                        setVisible((p) => !p)
                                    }}
                                    style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "20px",
                                        background: "var(--ui-color-primary, #2b7cd3)",
                                        cursor: "pointer",
                                    }}
                                >
                                    <Plus className="text-white" strokeWidth={2} size={15} />
                                </CFormLabel>
                            </div> */}
            </div>
          </CAccordionHeader>
          <CAccordionBody>
            {/* <Graytextarea
               
                // disabled={true}
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setVisible((p) => !p)
                }}
                value={textValue}
                style={{
                  backgroundColor: '#282828',
                  color: 'white',
                  border: '1px solid #444',
                }}
                // onChange={(e) => {
                //     setModalText(e.target.value)
                //     noteStructureRef.current.alertData[diagnosisName] = e.target.value
                // }}
              /> */}
            <div
              style={{
                minHeight: '50px',
                backgroundColor: '#282828',
                color: 'white',
                border: '1px solid #989898',
                padding: '10px',
                borderRadius: '4px',
                cursor: 'pointer',
                whiteSpace: 'pre-line',
              }}
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                setVisible((p) => !p)
              }}
            >
              {textValue || (
                <span
                  style={{
                    fontSize: '14px',
                    color: '#989898',
                  }}
                >
                  Enter Alert
                </span>
              )}
            </div>
          </CAccordionBody>
        </CAccordionItem>
      </div>
      <CModal size="lg" visible={visible} onClose={() => setVisible(false)} alignment="center" aria-labelledby="LiveDemoExampleLabel">
        <CModalHeader
          style={{
            backgroundColor: '#282828',
            borderBottom: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            color: 'white',
            position: 'relative',
            borderRadius: '10px 10px 0 0',
          }}
        >
          <CModalTitle style={{ textAlign: 'center', color: 'white', width: '100%' }}>Alert for {diagnosisName}</CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            backgroundColor: '#282828',
            color: 'white',
          }}
        >
          <Graytextarea
            style={{
              backgroundColor: '#191919',
              color: 'white',
              border: '1px solid #444',
              height: '200px',
            }}
            value={modalText}
            onChange={(e) => {
              setModalText(e.target.value)
              noteStructureRef.current.alertData[diagnosisName] = e.target.value
            }}
            placeholder="Enter alert message"
          />
        </CModalBody>
        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            paddingTop: '10px',
            borderRadius: '0 0 10px 10px',
          }}
        >
          <CButton
            style={{
              backgroundColor: '#4363F2',
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            onClick={handleSubmit}
            variant="outline"
            color="primary"
          >
            Save
          </CButton>
          <CButton
            style={{
              backgroundColor: '#333',
              border: '1px solid gray',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            onClick={() => setVisible(false)}
          >
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ProviderAlert
